// extracted by mini-css-extract-plugin
export default {"page_wrapper":"layout_page_wrapper__QsBXb","page_content":"layout_page_content__jiLdo"};